const apiUrl = process.env.REACT_APP_API_URL;

export const inactivateUser = async(id) => {
    try {
        const token = sessionStorage.getItem('token');
        const requestOptions = {
            method: 'PUT', 
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
             },
          };
          const url = `${apiUrl}/api/users/inactivateUser/${id}`;
          const response = await fetch(url, requestOptions);
          const jsonResponse =  await response.json();
          return jsonResponse.result;
    } catch (error) {
        return false;
    }
}

export const activateUser = async(id) => {
    try {
        const token = sessionStorage.getItem('token');
        const requestOptions = {
            method: 'PUT', 
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
             },           
          };
          const url = `${apiUrl}/api/users/activateUser/${id}`;
          const response = await fetch(url, requestOptions);
          const jsonResponse =  await response.json();
          return jsonResponse.result;
    } catch (error) {
        return false;
    }
}


export const getAll = async() => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/users/getAll`;       
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },    
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return []
    }
}